/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "APV2PaymentDetailsPageService";
const log: any = LoggerModule.getInstance();

export class APV2PaymentDetailsPageService {
  private static instance: APV2PaymentDetailsPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): APV2PaymentDetailsPageService {
    if (!APV2PaymentDetailsPageService.instance) {
      APV2PaymentDetailsPageService.instance = new APV2PaymentDetailsPageService(props);
    }
    return APV2PaymentDetailsPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    return content;
  }
  public async createTransaction(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    console.log(args);
    compProps = await agent.createTransaction(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

}
